import { UserInfo } from '@shared/models/user-info.model';

export enum TreatyTypeEnum {
  Casualty = 'casualty',
  Property = 'property',
}

export type TreatyType = TreatyTypeEnum.Casualty | TreatyTypeEnum.Property;

export type Treaty = {
  treatyId: number;
  isProperty: boolean;
  isCasualty: boolean;
  treatyState: string;
  treatyNotes: string;
  createdDatetime: string;
  createdBy: UserInfo;
  createdByName?: string;
  type?: string;
};
